allow-visible-on-all-workspaces:
  title: Cross-Space Visibility
  description: Allow the window to be visible on all workspaces, macOS only.
spotlight:
  errors:
    unknown: Unknown error
    prefix: 'Something went wrong: {message}'
    shortcutRegistrationFailed: 'Something went wrong: failed to register Spotlight shortcut.'
pages:
  modules:
    mcp-server:
      description: Connect and manage MCP server and tools
      title: MCP Server
  system:
    sections:
      section:
        window-shortcuts:
          title: Keyboard Shortcuts
    window-shortcuts:
      description: Modify the window shortcuts.
      title: Window Shortcuts
      empty: Not set
      spotlight:
        title: Spotlight shortcut
        description: Click the shortcut, then press a new shortcut. Press Esc to cancel.
      actions:
        recording: Press keys
        reset: Reset
      errors:
        load: Failed to load shortcut
        conflict: Shortcut already in use.
        failed: Failed to update shortcut
        requiresModifier: Use at least one of Cmd, Ctrl, Alt, or Super.
      toggle-move:
        label: Toggle Move
      toggle-resize:
        label: Toggle Resize
      toggle-ignore-mouse-event:
        label: Toggle Ignore Mouse Event
      press-keys: Press Keys...
    desktop-control:
      title: Desktop Control
      description: Allow the agent to control mouse, keyboard, and clipboard on this computer.
      section:
        title: Agent desktop control
        description: >-
          When enabled, chat tools can inject mouse and keyboard input.
          By default every action still asks for OS confirmation.
      enabled:
        label: Enable desktop control
        description: Master switch. Keep off unless you want the agent to operate this PC.
      always-allow:
        label: Always allow (dangerous)
        description: >-
          Skip the OS confirmation dialog for every action.
          Only use this if you fully trust the model and your setup.
        toast: Always-allow is on. Desktop actions will not ask for confirmation.
      emergency-stop:
        title: Emergency stop is active
        description: >-
          Desktop injection is blocked. Clear emergency stop, then turn the master switch on again if needed.
          Shortcut: Ctrl/Cmd+Shift+F12.
        clear: Clear emergency stop
        cleared: Emergency stop cleared
      hints:
        emergency-shortcut: Emergency stop shortcut is Ctrl+Shift+F12 (Cmd+Shift+F12 on macOS).
      errors:
        load: Failed to load desktop control settings
        save: Failed to update desktop control settings
    developer:
      sections:
        section:
          use-window-mouse:
            title: useWindowMouse Tool
            description: Test the Electron window cursor position
devtools:
  title: Developer
  pages:
    context-flow:
      title: Context Flow
    lag-visualizer:
      title: Lag Visualizer
    performance-visualizer:
      title: Performance Visualizer
      description: Toggle FPS/long task/memory overlay
    markdown-stress:
      title: Markdown Stress
      description: Stress markdown parsing and rendering with heavy chat payloads
    io-tracer:
      title: IO Tracer
    widgets-calling:
      title: Widget Calling

screen-capture:
  permissions-prompt:
    title: Screen Capture
    description: To capture screens or windows, screen and system audio recording permissions are required.
    open-preferences: Open System Preferences
    dismiss: Dismiss
    instructions:
      step-1: Open "System Preferences", select "Privacy & Security" from the sidebar.
      step-2: In the "Screen & System Audio Recording" and "System Audio Recording Only" sections, turn on the switches for AIRI.
      step-2-note: If AIRI is not listed, please add it manually by clicking the "+" button and selecting AIRI from the Applications folder.
